import RatingPage from '@components/RatingPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const RATING_TO_ANSWER = {
  '1': 'Much less than average',
  '2': 'Less than average',
  '3': 'About average',
  '4': 'More than average',
  '5': 'Much more than average',
}

export default function SugarIntakePage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(RATING_TO_ANSWER).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the rating value from the form
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string

    if (!rating) return

    const answer = {
      question_key: 'sugar_intake',
      question: 'Do you think you eat more or less sugar than the average?',
      answer_key: rating,
      answer: RATING_TO_ANSWER[rating as keyof typeof RATING_TO_ANSWER],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer('sugar_intake', answer)
    }
  }

  return (
    <RatingPage
      title="pages.onboarding.sugarIntake.heading"
      minSubtitle="pages.onboarding.sugarIntake.options.less"
      maxSubtitle="pages.onboarding.sugarIntake.options.more"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
